import { graphql } from "react-relay";

export const RemoveNotificationRuleMutation = graphql`
  mutation RemoveNotificationRuleMutation(
    $input: RemoveNotificationRuleInput!
  ) {
    removeNotificationRule(input: $input) {
      problems {
        message
      }
      removed {
        id @deleteRecord
      }
    }
  }
`;
